import { z } from "zod";

/**
 * エラーの形は RFC 9457（Problem Details for HTTP APIs、docs/04 §1.2）。
 * `title` は画面にそのまま出せる日本語の文（docs/10 §5.1「間違いは色でなく文で」）。
 * `code` は画面が分岐に使う識別子（AUTH_EMAIL_TAKEN など。015 の RAISE EXCEPTION と同じ文字列）。
 */
export const Problem = z.object({
  type: z.string().default("about:blank"),
  title: z.string(),
  status: z.number().int(),
  detail: z.string().optional(),
  code: z.string().optional(),
  /** 入力欄ごとの文。キーは欄の名前 */
  errors: z.record(z.string(), z.string()).optional(),
});
export type Problem = z.infer<typeof Problem>;
